import React, { useEffect } from 'react';
import { Burger, Divider, Drawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { useContent } from '@/providers/ContentProvider';
import { AppUser, UserType } from '@/types/user';
import { LanguageSelect } from './LanguageSelect';
import { NavLink } from '../../navlink/NavLink';
import { AppPaths } from '@/configs/appPaths';
import styles from '../Navbar.module.scss';

interface Props {
	baseSlug: string;
}

export const HamburgerMenu: React.FC<Props> = ({ baseSlug }) => {
	const { getContent } = useContent();

	const [opened, { toggle, close }] = useDisclosure(false);

	const { pathname } = useLocation();
	useEffect(() => {
		close();
	}, [pathname]);

	const { logout } = useAuth();
	const user = useAuth().user as AppUser;

	let menuItems: React.ReactNode = null;
	switch (user.userType) {
		case UserType.CLIENT:
			menuItems = (
				<nav className={styles.mobileMenu}>
					<NavLink className={styles.item} to={AppPaths.USER_NOTIFICATIONS} end>
						{getContent(`${baseSlug}userNotifications`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.ORDERS} end>
						{getContent(`${baseSlug}orders`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.OFFERS} end>
						{getContent(`${baseSlug}offers`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.COMPLAINTS} end>
						{getContent(`${baseSlug}complaints`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.FILES} end>
						{getContent(`${baseSlug}files`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.CLIENTS} end>
						{getContent(`${baseSlug}employees`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.CONTACTS} end>
						{getContent(`${baseSlug}contacts`)}
					</NavLink>
					<Divider w="100%" my="sm" />
					<NavLink className={styles.item} to={AppPaths.ACCOUNT} end>
						{getContent(`${baseSlug}userAccount`)}
					</NavLink>
					<NavLink to="" onClick={logout}>
						{getContent(`${baseSlug}logout`)}
					</NavLink>
					<LanguageSelect />
				</nav>
			);

			break;

		case UserType.MERCHANT:
			menuItems = (
				<nav className={styles.mobileMenu}>
					<NavLink className={styles.item} to={AppPaths.COMPLAINTS} end>
						{getContent(`${baseSlug}complaints`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.CLIENTS} end>
						{getContent(`${baseSlug}employees`)}
					</NavLink>
					<Divider w="100%" my="sm" />
					<NavLink className={styles.item} to={AppPaths.ACCOUNT} end>
						{getContent(`${baseSlug}userAccount`)}
					</NavLink>
					<NavLink to="" onClick={logout}>
						{getContent(`${baseSlug}logout`)}
					</NavLink>
					<LanguageSelect />
				</nav>
			);
			break;
	}

	return (
		<div className={styles.mobileMenuContainer}>
			<Burger
				size="md"
				opened={opened}
				onClick={toggle}
				aria-label={opened ? 'Close navigation' : 'Open navigation'}
			/>
			<Drawer
				opened={opened}
				onClose={close}
				classNames={{ header: 'd-none' }}
				size="100%"
			>
				{menuItems}
			</Drawer>
		</div>
	);
};
